import React, { useEffect, useState } from 'react';
import { ChevronUp } from 'lucide-react';

const FloatingActionButtons = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 250);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-3">
      {showScrollTop ? (
        <button
          type="button"
          onClick={scrollToTop}
          className="flex h-12 w-12 items-center justify-center rounded-full bg-accent text-white shadow-lg transition hover:opacity-90"
          aria-label="Scroll to top"
          title="Scroll to top"
        >
          <ChevronUp size={22} />
        </button>
      ) : null}
    </div>
  );
};

export default FloatingActionButtons;
